import { render } from "./StreamsWidgetPlaylistTab.vue?vue&type=template&id=8d4806b2"
import script from "./StreamsWidgetPlaylistTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidgetPlaylistTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamsWidgetPlaylistTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d4806b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d4806b2', __exports__)) {
    api.reload('8d4806b2', __exports__)
  }
  
  module.hot.accept("./StreamsWidgetPlaylistTab.vue?vue&type=template&id=8d4806b2", () => {
    api.rerender('8d4806b2', render)
  })

}


export default __exports__